export const formatDraft = (id, results) => {
  const {
    assignmentSheet,
    attachments,
    formData,
    sheetData = null,
    ...draftFields
  } = results?.draft ?? {};
  const {
    assignmentSheet: migratedAssignmentSheet,
    attachments: migratedAttachments,
    ...normalizedFormData
  } = formData ?? {};

  return {
    ...draftFields,
    assignmentSheet: assignmentSheet ?? migratedAssignmentSheet ?? null,
    attachments: attachments ?? migratedAttachments ?? [],
    formData: formData ? normalizedFormData : draftFields,
    sheetData,
    draftId: id,
    draftUpdatedAt: results?.updatedAt,
    legacyDraftId: results?.legacyId
  };
};
